import * as actionTypes from "./actionTypes";
import * as types from "./types";

//Extractor Job Schedules 
export const postEventTriggersRequest = (payload: types.IEventTriggersParams): types.PostEventTriggersRequest => ({
    type: actionTypes.POST_EVENTTRIGGERS_REQUEST,
    payload
});

export const postEventTriggersSuccess = (payload: types.IPostEventTriggersSuccessPayload): types.PostEventTriggersSuccess => ({
    type: actionTypes.POST_EVENTTRIGGERS_SUCCESS,
    payload
});

export const posteventTriggersFailure = (payload: types.IPostEventTriggersFailurePayload): types.PostEventTriggersFailure => ({
    type: actionTypes.POST_EVENTTRIGERRS_FAILURE,
    payload
});

// Put Events API
export const putEventsRequest = (
    eventId: string,
    payload: types.IEventsPutReq
): types.PutEventsRequest => ({
    type: actionTypes.PUT_EVENTTRIGGERS_REQUEST,
    eventId,
    payload
});

export const putEventsSuccess = (
    payload: types.IPutEventsSuccessPayload
): types.PutEventsSuccess => ({
    type: actionTypes.PUT_EVENTTRIGGERS_SUCCESS,
    payload,
});

export const putEventsFailure = (
    payload: types.IPutEventsFailurePayload
): types.PutEventsFailure => ({
    type: actionTypes.PUT_EVENTTRIGGERS_FAILURE,
    payload,
});

// DELETE Events

export const deleteEventsReq = (
    params: string
): types.DeleteEventsRequest => ({
    type: actionTypes.DELETE_EVENTTRIGGERS_REQUEST,
    params,
});

export const deleteEventsSuccess = (
    success: types.IDeleteEventsSuccess
): types.DeleteEventsSuccess => ({
    type: actionTypes.DELETE_EVENTTRIGGERS_SUCCESS,
    success,
});

export const deleteEventsFailure = (
    payload: types.IDeleteEventsFailurePayload
): types.DeleteEventsFailure => ({
    type: actionTypes.DELETE_EVENTTRIGGERS_FAILURE,
    payload,
});
